<template>
  <mt-loading-animation-linear v-if="!isLoaded || !assessmentPlan" />
  <div
    v-else
    :class="['respondents-table',
          {'respondents-table_loading': isRespondentsLoading}
      ]"
    style="width: 100%"
  >
    <div class="respondents-table__header">
      <app-dropdown
        :items="downloadPersonReportOptions"
        class="respondents-table__header__btn"
      >
        <template #header>
          <mt-button color="light-gray">
            <template #icon>
              <download-icon />
            </template>
            Скачать отчет
            <arrow-down-icon style="transform: rotate(180deg); margin-left: 8px" />
          </mt-button>
        </template>
      </app-dropdown>


      <mt-button
        color="light-gray"
        class="respondents-table__header__btn"
        :loading="exportRequestPending"
        @click="openDownloadRespondentListPopover"
      >
        <template #icon>
          <export-icon style="height: 24px; width: 24px;" />
        </template>
        Экспорт
        <arrow-down-icon style="transform: rotate(180deg); margin-left: 8px;" />
      </mt-button>

      <mt-filters
        style="margin-left: auto;"
        v-model:cols="cols"
        v-model:filters="filters"
        v-model:sort="sort"
        v-model:search="search"
        :filtersSettings="filtersSettings"
        :filter-visibility="false"
        @change="loadRespondents({page: 1})"
      />
    </div>
    <div class="respondents-table__body">
      <div
        ref="table"
        class="respondents-table__wrapper"
        v-dragscroll
      >
        <table>
          <thead>
          <tr>
            <th>
              <app-checkbox
                :checked="allItemsAreSelected"
                @change="toggleSelectAllItems"
                style="margin-bottom: 0"
              />
            </th>
            <th
              style="padding: 0"
              v-if="cols[0].visible"
            >
              <div class="respondents-table__cell__fullname-header respondents-table__cell__fullname-wrapper">
                Респондент
              </div>
            </th>
            <th v-if="cols[1].visible" class="respondents-table__border-left">Возраст</th>
            <th v-if="cols[2].visible" class="respondents-table__border-left">E-mail</th>
            <th
              v-if="cols[3].visible"
              class="respondents-table__border-left"
            >
              Примечание
            </th>
            <th v-for="formSetting in assessmentPlan.form_settings">{{ formSetting.name }}</th>
            <template
              v-for="(test, index) in testsCount"
              :key="index"
            >
              <th class="respondents-table__border-left" v-if="test.type === 'assessment' || !test.assessment_metric || test.assessment_metric == activeAssessmentMetricColumn">
                <div class="respondents-table__cell">
                  <task-icon
                    :type="test.type"
                    size="small"
                    class="respondents-table__header__icon mr-1"
                  />

                  <span>{{ test.name }}</span>

                  <mt-button
                    v-if="test.scales?.length || test.type == 'assessment'"
                    icon
                    :class="[
                          'respondents-table__header__toggler',
                          {
                            'respondents-table__header__toggler_active': test.uuid === activeTestScaleColumn || (test.type == 'assessment' && test.assessment_metric == activeAssessmentMetricColumn)
                          }
                        ]"
                    @click="toggleTestScaleColumnVisibility(test)"
                  >
                    <span class="respondents-table__header__toggler__icon" />
                  </mt-button>
                </div>
              </th>
              <th  v-show="test.uuid === activeTestScaleColumn">
                  <span>Дата (время) прохождения</span>
              </th>
              <th
                  v-show="test.uuid === activeTestScaleColumn"

              >
                <div class="respondents-table__cell">
                  <span>Число переходов</span>
                </div>
              </th>
              <th
                  v-show="test.uuid === activeTestScaleColumn && test.type !== 'assessment'"
                  v-for="(criteria, index) in test.scales"
                :key="index"
              >
                {{ criteria.name }}
              </th>
              <th v-if="test.session_enable_proctoring" v-show="test.uuid === activeTestScaleColumn">
                Доверие
              </th>
              <th v-if="test.session_enable_proctoring" v-show="test.uuid === activeTestScaleColumn">
                Заключение
              </th>
              <th v-if="test.session_enable_proctoring" v-show="test.uuid === activeTestScaleColumn">
                Отчет
              </th>
            </template>
            <th class="respondents-table__border-left">Балл</th>
            <th class="respondents-table__border-left">Оценка</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(respondent, index) in respondents"
            :key="respondent.uuid"
          >
            <td>
              <app-checkbox
                v-model="selected"
                :value="respondent.uuid"
              />
            </td>
            <td v-if="cols[0].visible">
              <div class="respondents-table__cell__fullname-header respondents-table__cell__fullname-wrapper">
              <component
                :is="respondentNameTag"
                :to="{
                    name: 'RespondentCabinet',
                    params: {
                      respondentUuid: respondent.uuid
                    }
                  }"
                class="respondents-table__cell_fullname"
              >
                {{ respondent.full_name }}
              </component>
              </div>
            </td>
            <td v-if="cols[2].visible" class="respondents-table__border-left">{{ respondent.year }}</td>
            <td v-if="cols[1].visible" class="respondents-table__border-left">{{ respondent.email }}</td>
            <td
              v-if="cols[3].visible"
              :class="['respondents-table__border-left respondents-table__td_comment', {
                  'respondents-table__td_commenting': respondent.is_commenting,
                  'respondents-table__td_success': respondent.is_success
                }]"
            >
              <app-textarea
                v-model="respondent.comment"
                hide-details
                :init-height="38"
                :max-length="200"
                :max-lines="4"
                @submit="$event.target.blur()"
                @change="makeComment(respondent)"
              />

              <tick-icon class="respondents-table__td_comment__tick" />
            </td>
            <td v-for="formSetting in assessmentPlan.form_settings">{{ getRespondentPlanFormSettings(respondent.uuid, formSetting.uuid) }}</td>
            <template v-for="(task, index) in respondent.tests">
              <td
                v-if="task.type === 'confirmation'"
                :key="index"
                class="respondents-table__border-left"
              >
                <mt-checkbox
                  v-model="task.isChecked"
                  disabled="disabled"
                  class="ml-auto mr-auto"
                />
              </td>
              <template v-else>
                <td
                  v-if="task.type === 'assessment' || !task.assessment_metric || task.assessment_metric == activeAssessmentMetricColumn"
                  :key="index"
                  :class="[
                        'respondents-table__border-left',
                        'respondents-table__td',
                        {
                          'respondents-table__td_expert': task.type === 'expert'
                        }
                    ]"
                >
                  <div class="respondents-table__cell">
                    <template v-if="task.is_calculating">
                      Cчитывается...
                    </template>
                    <template v-else>
                      <component
                        :is="canEvaluateTask(task) ? 'button' : 'div'
                          "
                        :class="[
                            'respondents-table__cell__more',
                            {
                              'respondents-table__cell__more_failed': task.failed,
                              'respondents-table__cell__more_expert': canEvaluateTask(task)
                            }
                          ]"
                        @click="isTaskTypeExpertAndPlanNotCompleted(task) ? openTaskModal(task, respondent) : null"
                      >
                        <template v-if="task.type !== 'assessment'">
                          <template v-if="['test', 'test_pro'].includes(task.type)">
                            {{ !task.completed ? "-" : task.current }} из {{ task.total }}
                          </template>
                          <template v-else>
                            <template v-if="!task.current && !task.total_with_weight">
                              -
                            </template>
                            <template v-else>
                              {{ !task.completed ? "-" : task.current_with_weight }} из {{ task.total_with_weight }}
                            </template>
                          </template>
                        </template>
                        <button
                          v-if="(task.type !== 'assessment' && task.reports?.length) || (task.type === 'assessment' && task.completed)"
                          class="ml-2"
                          @click="openDownloadReportModal(respondent.uuid, task)"
                        >
                          <mtSvg
                            name="download"
                            color="#00788C"
                          />
                        </button>
                        <img
                          v-if="task.notifications"
                          src="/img/icons/notification.svg"
                          alt=""
                          class="respondents-table__cell__notification"
                        />
                      </component>
                    </template>
                  </div>
                </td>
                <td v-show="task.uuid === activeTestScaleColumn">
                  <div v-if="task.session_start_date"> {{ task.session_start_date }}</div>
                  <div v-else>-</div>
                </td>
                <td
                  v-show="task.uuid === activeTestScaleColumn"
                >
                  {{ task.switching_count }}
                </td>
                <td
                  v-show="task.uuid === activeTestScaleColumn && task.type !== 'assessment'"
                  v-for="(scale, scaleIndex) in task.scales"
                  :key="scaleIndex"
                  class="respondents-table__cell_scale"
                >
                  <template v-if="scale.current === 0 && scale.max === 0">
                    -
                  </template>
                  <template v-else>
                    <Popper
                      v-if="canEvaluateTask(task)"
                      :show="openedPopper === `${respondent.uuid} ${scale.uuid}`"
                      arrow
                      class="respondents-table__evaluation-trigger"
                      @open:popper="onOpenScaleMarkRangePopper(respondent.uuid, scale.uuid)"
                    >
                      <button
                        class="respondents-table__evaluation-trigger__content"
                        @click="openRangePopover(scale, task, respondent)"
                      >
                        <span>
                          {{
                            (!task.completed || scale.current === null) ? "-" : scale.current_with_weight
                          }} из {{ scale.max_with_weight }}
                        </span>

                        <span class="respondents-table__evaluation-trigger__status">
                          <app-circle-loader
                            size="small"
                            :class="['respondents-table__evaluation-trigger__loader', {
                                  'respondents-table__evaluation-trigger__loader_active': false
                                }]"
                          />

                          <tick-icon
                            :class="['respondents-table__evaluation-trigger__loader', {
                                  'respondents-table__evaluation-trigger__loader_active': false
                                }]"
                          />
                        </span>

                        <span
                          class="respondents-table__evaluation-trigger__triangle"
                          @click.stop="isTaskTypeExpertAndPlanNotCompleted(task) ? openTaskModal(task, respondent) : null"
                        >
                          <arrow-diagonal-icon class="respondents-table__evaluation-trigger__triangle__icon" />
                        </span>
                      </button>

                      <template #content>
                        <div>
                          <div class="d-flex">
                            <div class="scale-mark-range__desc">
                              <p>
                                <strong>Шаг:</strong>
                                {{ scale.step }}
                              </p>
                              <p>
                                <strong>Множитель: </strong>
                                {{ scale.weight }}
                              </p>
                            </div>

                            <scale-mark-autocomplete
                              v-model="scale.current"
                              id="scale_mark_range"
                              :key="scale.uuid"
                              :items="scale.grades"
                              :min="scale.min"
                              :max="scale.max"
                              :data-respondent="respondent.uuid"
                              :data-criteria="scale.uuid"
                              @success="setScaleMark(respondent.uuid, task.uuid, task.session_uuid, scale)"
                            />
                          </div>
                        </div>
                      </template>
                    </Popper>
                    <template v-else>
                      {{ !task.completed ? '-' : scale.current_with_weight }} из {{ scale.max_with_weight }}
                    </template>
                  </template>
                </td>
                <td v-if="task.session_enable_proctoring" v-show="task.uuid === activeTestScaleColumn">
                  {{ typeof(task?.session_proctoring_results?.score)==='number' ? task.session_proctoring_results.score : "-" }}
                </td>
                <td v-if="task.session_enable_proctoring" v-show="task.uuid === activeTestScaleColumn">
                  <span v-if="task?.session_proctoring_results?.conclusion?.value">{{ task.session_proctoring_results.conclusion.value }}</span>
                  <span v-else>-</span>
                </td>
                <td v-if="task.session_enable_proctoring" v-show="task.uuid === activeTestScaleColumn">
                  <a v-if="task?.session_proctoring_results?.link" :href="task.session_proctoring_results.link" target="_blank">Отчет</a>
                  <span v-else>-</span>
                </td>
              </template>
            </template>
            <td class="respondents-table__border-left">
              {{ respondent.balls }}
              <template v-if="respondent.is_calculating">
                (Cчитывается...)
              </template>
            </td>
            <td class="respondents-table__border-left">
              <template v-if="!respondent.is_calculating">
                {{ respondent.grade }}
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <mt-pagination
        v-if="pagination?.total"
        :total="pagination?.total"
        :page="pagination.page"
        :perPage="pagination.perPage"
        class="respondents-table__pagination"
        @change="loadRespondents"
      />
    </div>
  </div>
  <teleport to="body">
    <download-report-popover
      :visibility="isDownloadReportVisible"
      :reports="clipboardTask?.reports"
      :view_download_html="true"
      @close="closeDownloadReportModal"
      @download="downloadReport"
      @downloadHTML="downloadReportHTML"
    />
    <DownloadPersonReportPopover
      :visibility="showDownloadPersonReportPopup"
      :view_download_html="false"
      :personReports="selectedPersonReports"
      @close="closeDownloadPersonReportPopover"
      @download="downloadPersonReport"
    />
    <mt-popover
      v-model="shownDownloadRespondentListPopover"
      style="max-width: none;"
    >
      <div class="mt-download-report">
        <div class="mt-download-report__title">
          Отображение столбцов
        </div>
        <div class="mt-download-report__views">
          <div class="mt-download-report__views-person">
            <div class="mt-res-person-report-options">
              <app-checkbox
                v-model="visibleColumns"
                value="score"
                class="mt-download-report__views-person-checkbox"
              >
                <template #label>
                  Баллы
                </template>
              </app-checkbox>
            </div>
          </div>
          <mt-button
            class="mt-download-report__next"
            style="margin-top: 20px;"
            @click="exportUsers"
          >
            Скачать
          </mt-button>
        </div>
      </div>
    </mt-popover>
  </teleport>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MtCheckbox from "@/components/UI/mtCheckbox/index.vue";
import MtPagination from "@/components/UI/mtPagination/mtPagination.vue";
import MtFilters from "@/components/UI/mtFilters/mtFilters.vue";
import MtSvg from "@/components/UI/mtSvg/index.vue";
import api from "@/network";
import { dragscroll } from "vue-dragscroll";
import MtDialog from "@/components/UI/mtDialog/mtDialog.vue";
import FileDownloadCard from "@/components/workspace/assessmentPlans/plans/fileDownloadCard/index.vue";
import MtLoadingAnimationLinear from "@/components/UI/mtLoadingAnimationLinear/mtLoadingAnimationLinear.vue";
import DownloadReportPopover from "@/components/workspace/testLibrary/results/DownloadReportPopover/index.vue";
// import externalApi from "@/network/external";
import AppTooltip from "@/components/UI/AppTooltip/AppTooltip.vue";
import MtButton from "@/components/UI/mtButton/index.vue";
import ExportIcon from "@/components/icons/ExportIcon.vue";
import MtPopover from "@/components/UI/mtPopover/mtPopover.vue";
import MtLinearProgress from "@/components/UI/mtLinearProgress/mtLinearProgress.vue";
import ScaleMarkRange from "@/components/workspace/ScaleMarkRange.vue";
import AppCircleLoader from "@/components/UI/AppCircleLoader.vue";
import Popper from "vue3-popper";
import TaskIcon from "@/components/workspace/assessmentPlans/plans/TaskIcon.vue";
import TickIcon from "@/components/icons/TickIcon.vue";
import PlayIcon from "@/components/icons/PlayIcon.vue";
import ScaleMarkAutocomplete from "@/components/workspace/ScaleMarkAutocomplete.vue";
import ArrowDiagonalIcon from "@/components/icons/ArrowDiagonalIcon.vue";
import usePlansStore from "@/store/plans.store";
import { storeToRefs } from "pinia";
import useRespondentsStore from "@/store/respondents.store";
import AppTextarea from "@/components/UI/AppTextarea/AppTextarea.vue";
import plansAdminApi from "@/api/plans-admin.api";
import ArrowDownIcon from "@/components/icons/ArrowDownIcon.vue";
import DownloadIcon from "@/components/icons/DownloadIcon.vue";
import AppDropdown from "@/components/UI/AppDropdown/AppDropdown.vue";

import DownloadPersonReportPopover
  from "@/components/workspace/assessmentPlans/results/DownloadPersonReportPopover/index.vue";
import AppCheckbox from "@/components/UI/AppCheckbox/AppCheckbox.vue";

import { uniqBy } from "lodash";
import useToast from "@/components/UI/AppToast/useToast.js";
import PersonReportOptions from "@/components/workspace/assessmentPlans/results/DownloadPersonReportPopover/PersonReportOptions/index.vue";
import DownloadStub from "@/components/workspace/assessmentPlans/results/DownloadPersonReportPopover/DownloadStub/index.vue";
import DownloadOptions from "@/components/workspace/assessmentPlans/results/DownloadPersonReportPopover/DownloadOptions/index.vue";
import mtPopover from "@/components/UI/mtPopover/mtPopover.vue";

export default {
  name: "ExpertReviewTable",
  components: {
    mtPopover, DownloadOptions, DownloadStub, PersonReportOptions,
    AppDropdown,
    AppCheckbox,
    DownloadPersonReportPopover,
    DownloadIcon,
    ArrowDownIcon,
    AppTextarea,
    ArrowDiagonalIcon,
    ScaleMarkAutocomplete,
    PlayIcon,
    TickIcon,
    TaskIcon,
    AppCircleLoader,
    ScaleMarkRange,
    MtLinearProgress,
    MtPopover,
    ExportIcon,
    MtButton,
    AppTooltip,
    DownloadReportPopover,
    MtLoadingAnimationLinear,
    FileDownloadCard,
    MtDialog,
    MtSvg,
    MtFilters,
    MtPagination,
    MtCheckbox,
    Popper
  },
  directives: { dragscroll },
  data: () => ({
    activeTestColumn: null,
    cols: [
      {
        "title": "ФИО",
        "stub": "full_name",
        "visible": true,
        "filter": "string",
        "filterable": false,
        "sortable": true,
        "showable": false
      },
      {
        "title": "Email",
        "stub": "email",
        "visible": true,
        "filter": "string",
        "filterable": true,
        "sortable": true,
        "showable": true
      },
      {
        "title": "Возраст",
        "stub": "birthday",
        "visible": true,
        "filter": "date",
        "filterable": false,
        "sortable": true,
        "showable": true
      },
      {
        "title": "E-mail",
        "stub": "email",
        "visible": true,
        "filter": "email",
        "filterable": false,
        "sortable": true,
        "showable": true
      },
      {
        "title": "Примечание",
        "stub": "comment",
        "visible": true,
        "filter": "date",
        "filterable": false,
        "sortable": false,
        "showable": true
      }
    ],
    pagination: {
      page: 1,
      perPage: 15,
      total: 0
    },
    filtersSettings: {},
    sort: null,
    search: {},
    filters: [],
    customFilters: [],

    selected: [],
    visibleColumns: ['score'],

    clipboardTask: null,
    selectedResultsReport: [],

    isDownloadReportVisible: false,
    isLoaded: false,

    activeTestScaleColumn: null,
    activeAssessmentMetricColumn: null,
    exportRequestPending: false,

    openedPopper: "",
    showDownloadPersonReportPopup: false,
    shownDownloadRespondentListPopover: false
  }),
  setup() {
    const plansStore = usePlansStore();
    const { plan } = storeToRefs(plansStore);

    const respondentsStore = useRespondentsStore();
    const { respondents, isRespondentsLoading } = storeToRefs(respondentsStore);

    return {
      assessmentPlan: plan,
      respondentsStore,
      respondents,
      isRespondentsLoading
    };
  },
  computed: {
    ...mapGetters(["authUser", "authUserRoleSlug"]),

    isUserAdmin() {
      return this.authUserRoleSlug === "admin";
    },

    testsCount() {
      if (this.respondents.length === 0) return [];

      return this.respondents[0].tests;
    },
    respondentNameTag() {
      return this.authUser?.role?.slug === "admin" ? "router-link" : "span";
    },
    respondentPlanFormSettings() {
      if (this.respondents.length === 0) return {};
      let result = {};
      this.respondents.forEach(respondent => {
        respondent.form_settings.forEach(setting => {
          if (setting.formable_type === "plan") {

            result[respondent.uuid][setting.uuid] = setting.value;
          }
        });
      });
      return result;
    },
    computedFilters: {
      get() {
        return this.filters;
      },
      set(newValue) {
        this.updateFilters(newValue);
      }
    },
    downloadPersonReportOptions() {
      return [
        {
          label: "в формате pdf, docx",
          onClick: this.openDownloadPersonReportPdfPopover
        }
      ];
    },

    selectedRespondents() {
      return this.respondents.filter((respondent) => this.selected.includes(respondent.uuid));
    },

    selectedPersonUserSessions() {
      let personUserSessions = [];

      this.selectedRespondents.forEach((respondent) => {
        if (respondent.tests) {
          respondent.tests.forEach((test) => {
            if (test.reports && test.reports.length) {
              personUserSessions.push({
                "uuid_session": test.session_uuid,
                "test_uuid": test.uuid,
                "uuid_user": respondent.uuid
              });
            }
          });
        }
      });

      return personUserSessions;
    },

    selectedPersonReports() {
      let personReports = [];

      this.selectedRespondents.forEach((respondent) => {
        if (respondent.tests) {
          respondent.tests.forEach((test) => {
            if (test.reports && test.reports.length) {
              test.reports.forEach((report) => {
                report.testUuid = test.uuid;
                report.testType = test.type;
                report.testName = test.name;
              });

              personReports.push({
                "testUuid": test.uuid,
                "testTitle": test.title,
                "reports": test.reports,
                "uuidSession": test.session_uuid,
                "uuidUser": respondent.uuid
              });
            }
          });
        }
      });

      return uniqBy(personReports, "testUuid");
    },

    allItemsAreSelected() {
      return this.respondents.length === this.selected.length;
    },
  },
  methods: {
    ...mapActions('results', ['exportResultsReportHTML','downloadResultsReport']),

    getRespondentPlanFormSettings(respondentUuid, settingUuid) {
      if (this.respondents.length === 0) return "-";
      for (var i = 0; i < this.respondents.length; ++i) {
        if (typeof this.respondents[i].form_settings === "object") {
          for (var z = 0; i < this.respondents[i].form_settings.length; ++z) {
            if ((typeof this.respondents[i].form_settings[z] === "undefined")) {
              return "-";
            }
            if (this.respondents[i].uuid === respondentUuid && this.respondents[i].form_settings[z].uuid === settingUuid) {
              switch (this.respondents[i].form_settings[z].type) {
                case "list":
                case "radio":
                  let value = this.respondents[i].form_settings[z].value ?? null;
                  let lists = this.respondents[i].form_settings[z].lists ?? [];
                  return lists.reduce((acc, scale) => {
                    if (scale.uuid === value) {
                      return scale.name;
                    }
                    return acc;
                  }, "-");
                default:
                  return this.respondents[i].form_settings[z].value;
              }
            }
          }
        }
      }

      return "-";
    },

    openDownloadPersonReportPdfPopover() {
      if (this.selected.length) {
        this.showDownloadPersonReportPopup = true;
      } else {
        this.$toast.warning("Выберите участников");
      }
    },

    isTaskTypeExpertAndPlanNotCompleted(task) {
      return task.type === "expert" && !this.assessmentPlan.isCompleted;
    },

    canEvaluateTask(task) {
      const accessAbleRoles = ["expert", "inspector", "admin"];
      const userHasAccess = accessAbleRoles.includes(this.authUserRoleSlug);

      return this.isTaskTypeExpertAndPlanNotCompleted(task) && userHasAccess;
    },

    async downloadReport({ format, variants, titles }) {
      const payload = [
        {
          format,
          variants,
          selected_results_report: this.selectedResultsReport
        }
      ];
      const response = await api.post("export/results", payload).catch(error => {
        if (error.status === 403) {
          this.$toast.error("План оценки заблокирован");
          this.closeDownloadReportModal();
        }
      });
      if (response.data?.url) {

        const reportLink = response.data.url;
        const fileNameInfo = response.data.FileNameInfo;
        const isGroup = variants.length > 1 || response.data.type == 'assessment';

        if (isGroup) {
          window.open(reportLink, "_blank");
        } else {
          // const response = await externalApi.get(`${reportLink}`, { responseType: "blob" });
          const response = await api.get(`export/downloadReport`, { responseType: 'blob', params: { reportLink } })

          if (response.data.size) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;

            //let fileName = `results__${ new Date().toLocaleDateString() }-${ new Date().toLocaleTimeString().replace(/:/g, '_') }.${ type }`;
            let fileName = fileNameInfo["FullName"] + "_" + fileNameInfo["TestName"] + "_" + titles[0] + "_" + fileNameInfo["TestNumber"] + "." + format;

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          } else {
            this.$toast.error("Отчёт не найден");
          }
        }
      }
    },

    async loadRespondents(newPagination) {
      let params = {
        page: newPagination?.page ?? this.pagination.page,
        per_page: newPagination?.perPage ?? this.pagination.perPage,
        settings: {}
      };

      if (this.sort) {
        params.settings.field = this.sort.field;
        params.settings.order = this.sort.order;
      }

      if (this.filters?.length) {
        params = {
          ...params,
          settings: {
            ...params.settings,
            filters: this.filters
          }
        };
      }

      if (this.filterByResult) {
        params = {
          ...params,
          result: this.filterByResult
        };
      }

      if (!!this.search.value) {
        params.settings["value"] = this.search.value;

        if (!!this.search.search) {
          params.settings["search"] = this.search.search;
        }
      } else {
        delete params.settings["search"];
      }

      const { meta } = await this.respondentsStore.getRespondents(this.$route.params.planUuid, params);
      this.pagination = {
        ...this.pagination,
        page: meta.current_page,
        perPage: meta.per_page,
        total: meta.total
      };
    },

    toggleTestScaleColumnVisibility(test) {
      if (test.type === 'assessment') {
        this.activeTestScaleColumn = null;
        this.activeAssessmentMetricColumn = this.activeAssessmentMetricColumn === test.assessment_metric ? null : test.assessment_metric;
      } else {
        this.activeTestScaleColumn = this.activeTestScaleColumn === test.uuid ? null : test.uuid;
      }
    },

    openDownloadReportModal(userUuid, task) {
      this.isDownloadReportVisible = true;

      this.selectedResultsReport = [{ "uuid_task": task.uuid, "uuid_session": task.session_uuid, "uuid_user": userUuid }];
      this.clipboardTask = task;
    },

    openDownloadRespondentListPopover() {
      this.shownDownloadRespondentListPopover = true;
    },

    closeDownloadPersonReportPopover() {
      this.showDownloadPersonReportPopup = false;
    },

    closeDownloadReportModal() {
      this.isDownloadReportVisible = false;

      this.selectedResultsReport = [];
      this.clipboardTask = null;
    },

    openTaskModal(test, respondent) {
      const isAdminResultsPage = this.$route.name === "AssessmentPlanSingleResults";
      const adminResultsPageRouteName = "PlanSingleResultsExpertTaskSingle";
      const isExpRespPage = this.$route.name === "ExpRespAssessmentPlanSingle";
      const expRespPageRouteName = "ExpertTaskSingle";

      const taskRoute = isExpRespPage ? expRespPageRouteName : isAdminResultsPage ? adminResultsPageRouteName : "";

      this.$router.replace({
        name: taskRoute,
        params: {
          planUuid: this.$route.params.planUuid,
          taskUuid: test.uuid,
          respondentUuid: respondent.uuid
        }
      });
    },

    async openRangePopover(criteria, test, respondent) {
      this.openedPopper = `${respondent.uuid} ${criteria.uuid}`;
    },

    async setScaleMark(respondentUuid, taskUuid, sessionUuid, scale) {
      const params = {
        respondentUuid,
        planUuid: this.$route.params.planUuid,
        sessionUuid: sessionUuid,
        taskUuid,
        scale
      };
      if (!this.isUserAdmin) {
        console.log("getprogress");
        // this.getPlanProgress({
        //   uuid: this.$route.params.planUuid
        // });
      }

      this.respondentsStore.setMarkToRespondentTaskScale(params);
    },

    onOpenScaleMarkRangePopper(respondent_uuid, criteria_uuid) {
      const target = document.querySelector(`#scale_mark_range[data-respondent="${respondent_uuid}"][data-criteria="${criteria_uuid}"]`);
      const input = target.querySelector(".app-autocomplete__input");
      nextTick(() => {
        input?.focus();
      });
    },

    onClickOutsideOfPopper(e) {
      if (e.target.closest(".popper")) return;

      const trigger = e.target.closest(".respondents-table__evaluation-trigger__content");
      if (trigger) {
        const popper = trigger.parentNode.nextSibling;
        const isActive = window.getComputedStyle(popper)["display"] === "block";
        if (!isActive) return;
      }

      this.openedPopper = "";
    },

    async makeComment(respondent) {
      respondent.is_commenting = true;
      await plansAdminApi.makeCommentPlan(
        this.$route.params.planUuid,
        respondent.uuid,
        respondent.comment
      ).then(() => {
        respondent.is_success = true;

        setTimeout(() => {
          respondent.is_success = false;
        }, 500);
      }).finally(() => {
        respondent.is_commenting = false;
      });
    },

    async downloadPersonReport({ format, variants, titles }) {
      let reports = [];
      const { toast } = useToast();

      this.selectedPersonUserSessions.forEach((selectedPersonUserSession) => {
        if (variants[selectedPersonUserSession.test_uuid]) {
          reports.push({
            "uuid_session": selectedPersonUserSession.uuid_session,
            "variants": variants[selectedPersonUserSession.test_uuid],
            "uuid_user": selectedPersonUserSession.uuid_user
          });
        }
      });

      const payload = [
        {
          format,
          selected_results_report: reports
        }
      ];

      const response = await api.post("export/results", payload).catch((error) => {
        toast.error(error?.data?.message ?? "Возникла ошибка при генерации отчета");
      });

      if (response.data?.url) {
        const fileNameInfo = response.data.FileNameInfo;
        let fileName = fileNameInfo["FullName"] + "_" + fileNameInfo["TestName"] + "_" + titles[0] + "_" + fileNameInfo["TestNumber"] + "." + format;
        const isGroup = !(reports.length === 1 && reports[0].variants.length === 1);

        this.downloadResultsReport({
          reportLink: response.data.url,
          type: format,
          isGroup: isGroup,
          fileName: fileName
        });
      }
    },

    async downloadReportHTML({ variant }) {
      const payload =
        {
          uuid_session: this.selectedResultsReport[0].uuid_session,
          uuid_task: this.selectedResultsReport[0].uuid_task,
          uuid_user: this.selectedResultsReport[0].uuid_user,
          variant: variant
        };

      // await this.exportResultsReportHTML(payload).then((response) => {
      //   if (response.data?.url) {
      //     window.open(response.data.url, "_blank");
      //   }
      // });

      const newTab = window.open('about:blank', '_blank');
      if (newTab) {
        const response = await this.exportResultsReportHTML(payload);
        const url = response.data?.url;
        if (url) {
          try {
            newTab.location = url;
          } catch (e) {
            window.open(url, '_blank', 'noopener,noreferrer');
          }
        }
      }
    },

    async showTaskDialog(taskUuid) {
      this.taskDialog = true;
      this.taskLoading = true;

      const { data } = await this.fetchTask({
        uuidPlan: this.$route.params.planUuid,
        uuid: taskUuid
      });

      this.chosenTask = taskSingleAdapter(data.data);
      this.taskLoading = false;

      const {meta} = await this.respondentsStore.getRespondents(this.$route.params.planUuid, params);
      this.pagination = {
        ...this.pagination,
        page: meta.current_page,
        perPage: meta.per_page,
        total: meta.total
      }
    },

    exportUsers() {
      if(this.selected.length === 0) {
        this.$toast.error("Для экспорта нужно выбрать не менее одного респондента");
        return;
      }

      this.exportRequestPending = true;
      
      api.get(`export/plans/${this.$route.params.planUuid}`, {
        responseType: "blob",
        params: {
            visibleColumns: this.visibleColumns,
            selected: this.selected
        }
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;

          let fileName = `Таблица_ведомости__${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString().replace(/:/g, "_")}.xlsx`;

          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        }).catch(error => {
        if (error.status === 403) {
          this.$toast.error("План оценки заблокирован");
          this.onClose();
        }
      })
        .finally(() => {
          this.exportRequestPending = false;
        });
    },

    toggleCriteriasDisplay(test) {
      if (this.activeTestColumn === test.uuid) {
        this.activeTestColumn = null;
        return;
      }
      this.activeTestColumn = test.uuid;
    },

    updateExpPlanList() {
      this.respondentsMeta.current_page = 1;
      this.loadRespondents();
    },

    toggleSelectAllItems() {
      if (this.allItemsAreSelected === false) {
        this.selected = [];
        this.respondents.forEach(respondent => {
          this.selected.push(respondent.uuid);
        });
      } else {
        this.selected = [];
      }
    }
  },
  mounted() {
    this.loadRespondents().finally(() => {
      this.isLoaded = true;
    });

    document.addEventListener("click", this.onClickOutsideOfPopper);
  },
  watch: {
    "$route"(to, from) {
      // Добавил обновление списка респондентов после закрытия модального окна, чтобы обновился статус отображения колокольчика, для админа
      if (from.name === "PlanSingleResultsExpertTaskSingle" && to.name === "AssessmentPlanSingleResults") {
        this.loadRespondents();
      }
      // Добавил обновление списка респондентов после закрытия модального окна, чтобы обновился статус отображения колокольчика, для эксперта
      if (from.name === "ExpertTaskSingle" && to.name === "ExpRespAssessmentPlanSingle") {
        this.loadRespondents();
      }
    }
  },
  unmounted() {
    document.removeEventListener("click", this.onClickOutsideOfPopper);
  }
};
</script>

<style lang="scss">
.respondents-table {
  background: #FFFFFF;
  border: 1px solid #DFE0EB;
  border-radius: 8px;
  position: relative;
  width: fit-content;
  max-width: 100%;
  transition: .3s opacity;

  &__body {
    position: relative;
  }

  &_loading {
    opacity: 0.7;
    pointer-events: none;
  }

  &__sort-icon {
    cursor: pointer;
    transition: transform .3s;

    &--active {
      transform: rotate(180deg);
    }
  }

  td.respondents-table__cell {
    white-space: pre-wrap;
    text-overflow: ellipsis;
    max-width: 300px;
  }

  .respondents-table__td {
    .respondents-table__cell {
      flex-direction: column;
      gap: 10px;
    }
  }

  &__cell {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    &__fullname {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      white-space: nowrap;

      &:focus {
        color: $green !important;
      }
    }

    &__fullname-header {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      text-align: center;
      justify-content: center;
    }

    &__fullname-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 12px;
      justify-content: center;
    }

    &__notification {
      width: 16px;
      margin-left: 8px;
    }

    &__more {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;

      &_failed {
        color: #C24020;
      }

      &_expert {
        color: $black;
        text-decoration: underline;

        &:focus {
          color: $green;
        }
      }
    }
  }

  a.respondents-table__cell_fullname {
    box-shadow: 4px 0 10px rgba(0, 0, 0, 0.05);
    color: #000;
    text-decoration: underline;
    transition: color .3s;

    &:hover {
      color: #00788C;
    }
  }

  &__edit {
    width: 18px;
    height: 18px;
    margin-left: 8px;

    svg {
      fill: $green;
    }
  }

  &__header {
    gap: 15px;
    height: 57px;
    display: flex;
    align-items: center;
    padding: 0 24px;

    &__toggler {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      margin-left: 5px;

      &__icon {
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 8px solid $green;
      }

      &_active {
        transform: scale(-1);
      }
    }
    
    @include max-lg {
      &__btn {
        .mt-button__icon {
          margin-right: 0;
        }
        .mt-button__content {
          display: none;
        }
      }
    }
  }

  &__wrapper {
    overflow-x: auto;
  }

  th, td {
    padding: 12px 10px;
    text-align: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.01em;
    color: #252733;
    vertical-align: middle;

    &:first-child {
      min-width: 20px;
      max-width: 20px;
      box-sizing: content-box;
      padding: 12px 10px;

      .app-form-block {
        margin-bottom: 0;
      }
    }

    &:nth-child(2) {
      position: sticky;
      left: 0;
      z-index: 2;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
  }

  th {
    //white-space: nowrap;
    background: #F0F1F7;
    box-shadow: inset 0px -1px 0px #E6E7E9;
  }

  td {
    height: 41px;
    padding: 0;

    &:nth-child(2) {
      border-bottom-color: transparent;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: #fff;
        z-index: -1;
        border-bottom: 1px solid #DFE0EB;
      }
    }
  }

  td.respondents-table__cell_scale {
    padding: 0;
  }

  tbody tr > * {
    border-bottom: 1px solid #DFE0EB;
    min-width: 130px;
  }

  table {
    width: 100%;
  }

  &__header {
    &__icon {
      &_pre {
        margin-right: 16px;
      }
    }
  }

  &__border-right {
    border-right: 2px solid #E6E7E9;
  }

  &__border-left {
    border-left: 2px solid #E6E7E9;
  }

  &__td {
    &_comment {
      min-width: 250px !important;
      max-width: 250px;
      padding: 0 !important;
      transition: opacity .3s;
      position: relative;

      &__tick {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: $green;
        opacity: 0;
        visibility: hidden;
        transition: opacity .3s;
        z-index: 2;
      }

      .custom-textarea textarea {
        border: none;
        padding-bottom: 8px;
        height: unset;
        border-radius: 0;

        &:focus {
          outline: 1px solid $green;
        }
      }
    }

    &_commenting {
      .custom-textarea {
        opacity: .3;
      }
    }

    &_success {
      .custom-textarea {
        opacity: .3;
      }

      .respondents-table__td_comment__tick {
        opacity: 1;
        visibility: visible;
      }
    }

    &_expert {
      /*padding: 0!important;
      .respondents-table__cell {
        padding: 12px 10px;
        background-color: $light-green;
        color: $green;
        cursor: pointer;
        &:hover {
          background-color: darken($light-green, 5%);
        }
        &:active {
          background-color: darken($light-green, 15%);
        }
      }*/
    }
  }

  &__pagination {
    padding: 0 20px;
    justify-content: flex-end;
    min-height: 60px;
  }

  .respondents-table__evaluation-trigger {
    display: flex !important;
    justify-content: center;
    margin: 0 !important;
    border: none !important;
    height: 100%;

    > div:first-child {
      width: 100%;
      height: 100%;
    }

    > div:last-child {
      width: 300px;
    }

    &__content {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      white-space: nowrap;
      height: 100%;
      gap: 5px;
      position: relative;

      span {
        &:first-child {
          margin-left: 20px;
        }
      }

      &:hover {
        cursor: pointer;
        box-shadow: 0 7px 12px rgba(0, 0, 0, 0.1);

        .respondents-table__evaluation-trigger__triangle {
          opacity: 1;
        }
      }

      &:focus, &:active {
        background-color: #eee;
      }
    }

    &__status {
      width: 15px;
      position: relative;

      > svg {
        width: 100%;
      }
    }

    &__loader {
      opacity: 0;

      &_active {
        opacity: 1;
      }

      &:last-child {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: $green;
      }
    }

    &__triangle {
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid $green;
      border-bottom: 20px solid transparent;
      position: absolute;
      right: 0;
      top: 0;
      opacity: 0;
      transition: opacity .3s;

      &__icon {
        width: 10px;
        height: 10px;
        transform: rotate(-90deg);
        margin-left: 8px;
        margin-bottom: 4px;
        color: #fff;
      }
    }
  }

  .expert-plan {
    &__export-btn {
      background: #F0F1F7;
      border-radius: 8px;
      height: 33px;
      width: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .custom-assessment {

    &__expander {
      margin-bottom: 20px;

      &__title {
        font-weight: 700;
        font-size: 19px;
        line-height: 24px;
        letter-spacing: 0.4px;
        color: #252733;
      }

      &__text {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #252733;
        white-space: pre-wrap;
      }

      &__file-title {
        font-weight: 600;
        margin-top: 30px;
      }

      .expander {
        &__item {
          &__header {
            padding-top: 0;
            @include max-xs {
              flex-wrap: nowrap;
              max-width: 100%;
            }
          }
        }
      }
    }
  }
}

:root {
  --popper-theme-background-color: #fff;
  --popper-theme-background-color-hover: #fff;
  --popper-theme-text-color: #000;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 10px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>

<style lang="scss">

.mt-download-report__views-person {
  margin-top: 15px;

  &-label {
    user-select: none;
    font-weight: 700;
    font-size: 18px;
    line-height: 23px;
    margin-bottom: 10px;
  }
}


.mt-res-person-report-options {

  &__option {
    font-family: 'Mulish';
    font-style: normal;
    border: 1.5px solid #DFE0EB;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    margin-top: 5px;

    &:first-child {
      margin-top: 0;
    }

    &-title {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.15px;
      color: #000000;
      user-select: none;
      width: 100%;
    }

    &-title-test {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.15px;
      color: #7b7a7a;
      user-select: none;
      width: 100%;
    }

    &-title-admin {
      text-decoration: underline;
    }

    &-title-admin:hover {
      color: #00788c;
      cursor: pointer;
    }


  }
}
.mt-download-report__title {
  margin-bottom: 24px;
}
.mt-download-report__views-person-checkbox {
  width: 100%;
  .checkbox {
    width: 100%;
  }
}
</style>